var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 1.90558H13.375V0.655579H12.125V1.90558H3.875V0.655579H2.625V1.90558H1.875C0.841125 1.90558 0 2.7467 0 3.78058V14.7806C0 15.8145 0.841125 16.6556 1.875 16.6556H14.125C15.1589 16.6556 16 15.8145 16 14.7806V3.78058C16 2.7467 15.1589 1.90558 14.125 1.90558ZM14.75 14.7806C14.75 15.1252 14.4696 15.4056 14.125 15.4056H1.875C1.53038 15.4056 1.25 15.1252 1.25 14.7806V6.53058H14.75V14.7806ZM14.75 5.28058H1.25V3.78058C1.25 3.43595 1.53038 3.15558 1.875 3.15558H2.625V4.40558H3.875V3.15558H12.125V4.40558H13.375V3.15558H14.125C14.4696 3.15558 14.75 3.43595 14.75 3.78058V5.28058Z",
    fill: "#00609B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 7.84308H2.375V9.09308H3.625V7.84308Z",
    fill: "#00609B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 7.84308H4.875V9.09308H6.125V7.84308Z",
    fill: "#00609B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 7.84308H7.375V9.09308H8.625V7.84308Z",
    fill: "#00609B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 7.84308H9.875V9.09308H11.125V7.84308Z",
    fill: "#00609B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 7.84308H12.375V9.09308H13.625V7.84308Z",
    fill: "#00609B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 10.3431H2.375V11.5931H3.625V10.3431Z",
    fill: "#00609B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 10.3431H4.875V11.5931H6.125V10.3431Z",
    fill: "#00609B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 10.3431H7.375V11.5931H8.625V10.3431Z",
    fill: "#00609B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 10.3431H9.875V11.5931H11.125V10.3431Z",
    fill: "#00609B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 12.8431H2.375V14.0931H3.625V12.8431Z",
    fill: "#00609B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 12.8431H4.875V14.0931H6.125V12.8431Z",
    fill: "#00609B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 12.8431H7.375V14.0931H8.625V12.8431Z",
    fill: "#00609B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 12.8431H9.875V14.0931H11.125V12.8431Z",
    fill: "#00609B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 10.3431H12.375V11.5931H13.625V10.3431Z",
    fill: "#00609B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/DateIcon.2a2d2c57d29a54c302f8492f39d6f2ff.svg";
export { ForwardRef as ReactComponent };